import { c as _c } from "react/compiler-runtime";
import { assignFolderToOrphanJobs } from '@/app/_workflows/assignFolderToOrphanJobs';
import calculateStartByDate from '@/app/_workflows/calculateStartByDate';
import { getSheetsDataExport } from '@/app/_workflows/getSheetsGrind';
import migrateDrawings from '@/app/_workflows/migrateDrawingInfo';
import { runMigrationScript } from '@/app/_workflows/migrateJobDatabase';
import { migrateJobFolderStructure } from '@/app/_workflows/migrateJobFolderStructure';
import migrateProjectInfo from '@/app/_workflows/migrateProjectInfo';
import { migrateSpJobFolder } from '@/app/_workflows/migrateSpJobFolder';
import { migrateWorkflowStatus } from '@/app/_workflows/migrateWorkflowStatus';
import { populateRouteOwner } from '@/app/_workflows/populateRouteOwner';
import { refreshPurchaseOrders } from '@/app/_workflows/refreshPurchaseOrders';
import { sendAllUsersUpdateToOpt } from '@/app/_workflows/sendAllUsersUpdateToOpt';
import { sendAllWorkstationGroupsToOpt } from '@/app/_workflows/sendAllWorkstationGroupsToOpt';
import { sendAllWorkstationsToOpt } from '@/app/_workflows/sendAllWorkstationsToOpt';
import { sendOperationTypesToOpt } from '@/app/_workflows/sendOperationTypesToOpt';
import { syncEntitiesToOpt } from '@/app/_workflows/SyncEntitiesToOpt';
import { updateOperationsStatus } from '@/app/_workflows/updateOperationsStatus';
import { AssignSalesforceIdModal } from '@/app/components/AssignSalesforceIdModal';
import { FixUsersFromSharepointModal } from '@/app/components/FixUsersFromSharepointModal';
import { FixWorkstationsFromCsvModal } from '@/app/components/FixWorkstationsFromCsvModal';
import { ImportJobChangeDateLogModal } from '@/app/components/ImportJobChangeDateLogModal';
import { ImportJobNotesModal } from '@/app/components/ImportJobNotesModal';
import { MigrateSiteDataModal } from '@/app/components/MigrateSiteDataModal';
import { SendCustomerReportNightlyModal } from '@/app/components/SendCustomerReportNightlyModal';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Backdrop } from '@shared/components/Backdrop';
import { Modal } from '@shared/components/Modal';
import { ToastType, useToast } from '@shared/context/Toast';
import { useServerHandler } from '@shared/hooks/useServerHandler';
import { useUser } from '@shared/hooks/useUser';
import { hasCRUDData } from '@shared/types';
import { dateToStringUTC } from '@shared/utils';
import { signOut } from 'next-auth/react';
import { useState, useTransition } from 'react';
interface MigrationStep {
  number: number;
  name: string;
  fileName: string;
  status: 'pending' | 'running' | 'completed' | 'error';
}
export const UserMenu: React.FC<{
  env: string;
}> = t0 => {
  const $ = _c(207);
  const {
    env
  } = t0;
  const [isSyncOptOpen, setSyncOptOpen] = useState(false);
  const [isMigrationModalOpen, setMigrationModalOpen] = useState(false);
  const [isDrawingMigrationOpen, setDrawingMigrationOpen] = useState(false);
  const [isImportJobNotesOpen, setImportJobNotesOpen] = useState(false);
  const [isImportChangeDateLogOpen, setImportChangeDateLogOpen] = useState(false);
  const [isAssignSalesforceIdOpen, setAssignSalesforceIdOpen] = useState(false);
  const [isFixUsersFromSharepointOpen, setFixUsersFromSharepointOpen] = useState(false);
  const [isFixWorkstationsFromCsvOpen, setFixWorkstationsFromCsvOpen] = useState(false);
  const [isMigrateSiteDataOpen, setMigrateSiteDataOpen] = useState(false);
  const [isSendCustomerReportNightlyOpen, setSendCustomerReportNightlyOpen] = useState(false);
  const [jobIds, setJobIds] = useState("");
  const [isDrawingMigrationRunning, setDrawingMigrationRunning] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [isSyncing, startTransition] = useTransition();
  const {
    isLoading,
    doServerAction
  } = useServerHandler();
  const {
    pushToast
  } = useToast();
  const {
    isAdmin,
    name,
    avatarUrl,
    lastLoginAt
  } = useUser();
  let t1;
  let t2;
  if ($[0] !== name) {
    const [firstName, lastName] = name.split(" ");
    t1 = firstName?.at(0) as string;
    t2 = lastName?.at(0);
    $[0] = name;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const initials = t1 + t2 as string;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      number: 1,
      name: "Fix Parts Quantity",
      fileName: "01_fix_parts_quantity",
      status: "pending"
    }, {
      number: 2,
      name: "Link Sheets to Jobs",
      fileName: "02_link_jobs_created_by_mulesoft_with_sheets",
      status: "pending"
    }, {
      number: 3,
      name: "Create Jobs",
      fileName: "03_create_jobs",
      status: "pending"
    }, {
      number: 4,
      name: "Migrate Job Planning",
      fileName: "04_migrate_job_planning",
      status: "pending"
    }, {
      number: 5,
      name: "Job Planning Connection",
      fileName: "05_job_planning_connect",
      status: "pending"
    }, {
      number: 6,
      name: "Cleanup Sheet Columns",
      fileName: "06_cleanup_sheet_columns",
      status: "pending"
    }];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [migrationScripts, setMigrationScripts] = useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event => {
      setAnchorElUser(event.currentTarget);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleOpenUserMenu = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setAnchorElUser(null);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleCloseUserMenu = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (stepNumber, status) => {
      setMigrationScripts(prev => prev.map(script => script.number === stepNumber ? {
        ...script,
        status
      } : script));
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const updateStepStatus = t6;
  let t7;
  if ($[7] !== currentStep || $[8] !== doServerAction || $[9] !== isLoading || $[10] !== pushToast) {
    t7 = (stepNumber_0, fileName) => {
      if (stepNumber_0 !== currentStep) {
        pushToast({
          message: "Please execute steps in order",
          type: ToastType.warning
        });
        return;
      }
      if (isLoading) {
        return;
      }
      updateStepStatus(stepNumber_0, "running");
      doServerAction(async () => runMigrationScript(fileName), response => {
        updateStepStatus(stepNumber_0, "completed");
        setCurrentStep(_temp);
        if (hasCRUDData(response)) {
          pushToast({
            message: "Migration script executed successfully",
            type: ToastType.success
          });
        } else {
          pushToast({
            message: "Migration script completed (no data returned)",
            type: ToastType.info
          });
        }
      }, () => {
        updateStepStatus(stepNumber_0, "error");
        pushToast({
          message: "Error executing migration script",
          type: ToastType.error
        });
      });
    };
    $[7] = currentStep;
    $[8] = doServerAction;
    $[9] = isLoading;
    $[10] = pushToast;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleRunMigration = t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      flexGrow: 0,
      marginLeft: 2
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      p: 0
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = name || "Avatar";
  const t11 = avatarUrl || undefined;
  const t12 = name ? initials : null;
  let t13;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t12) {
    t13 = <Tooltip title="Open settings"><IconButton onClick={handleOpenUserMenu} sx={t9}><Avatar alt={t10} src={t11} variant="rounded" sx={_temp2}>{t12}</Avatar></IconButton></Tooltip>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      mt: 6
    };
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      vertical: "top",
      horizontal: "right"
    };
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      vertical: "top",
      horizontal: "right"
    };
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = Boolean(anchorElUser);
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <MenuItem onClick={_temp3} divider={true}><Typography textAlign="center">Log out</Typography></MenuItem>;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== isAdmin) {
    t19 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp4} divider={true}><Typography textAlign="center">Link SP Folders</Typography></MenuItem>;
    $[22] = isAdmin;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== isAdmin || $[25] !== isSyncing) {
    t20 = isAdmin && <MenuItem sx={{
      display: "none"
    }} disabled={isSyncing} onClick={() => setSyncOptOpen(true)}><Typography textAlign="center">Sync entities to OPT</Typography></MenuItem>;
    $[24] = isAdmin;
    $[25] = isSyncing;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== isAdmin) {
    t21 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp5}><Typography textAlign="center">Download Grind PPTs</Typography></MenuItem>;
    $[27] = isAdmin;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== isAdmin) {
    t22 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setMigrationModalOpen(true)}><Typography textAlign="center">Migrate Database to Job</Typography></MenuItem>;
    $[29] = isAdmin;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== isAdmin) {
    t23 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setDrawingMigrationOpen(true)}><Typography textAlign="center">Update Job Drawings</Typography></MenuItem>;
    $[31] = isAdmin;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  let t24;
  if ($[33] !== isAdmin) {
    t24 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp6}><Typography textAlign="center">Migrate Workflow Status</Typography></MenuItem>;
    $[33] = isAdmin;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] !== isAdmin) {
    t25 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp7}><Typography textAlign="center">Calculate Start By Date</Typography></MenuItem>;
    $[35] = isAdmin;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== isAdmin) {
    t26 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp8}><Typography textAlign="center">Migrate Job Folder Structure</Typography></MenuItem>;
    $[37] = isAdmin;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== isAdmin) {
    t27 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp9}><Typography textAlign="center">Assign Folder to Orphan Jobs</Typography></MenuItem>;
    $[39] = isAdmin;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] !== isAdmin) {
    t28 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp10}><Typography textAlign="center">Update Operations Status</Typography></MenuItem>;
    $[41] = isAdmin;
    $[42] = t28;
  } else {
    t28 = $[42];
  }
  let t29;
  if ($[43] !== isAdmin) {
    t29 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp11}><Typography textAlign="center">Migrate Job Project</Typography></MenuItem>;
    $[43] = isAdmin;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== isAdmin) {
    t30 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp12}><Typography textAlign="center">Populate Route Owner</Typography></MenuItem>;
    $[45] = isAdmin;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  let t31;
  if ($[47] !== isAdmin) {
    t31 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp13}><Typography textAlign="center">Send Update All Users to OPT</Typography></MenuItem>;
    $[47] = isAdmin;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  let t32;
  if ($[49] !== isAdmin) {
    t32 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp14}><Typography textAlign="center">Send Operation Types to OPT</Typography></MenuItem>;
    $[49] = isAdmin;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== isAdmin) {
    t33 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp15}><Typography textAlign="center">Send All Workstations to OPT</Typography></MenuItem>;
    $[51] = isAdmin;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  let t34;
  if ($[53] !== isAdmin) {
    t34 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={_temp16}><Typography textAlign="center">Send All Workstation Groups to OPT</Typography></MenuItem>;
    $[53] = isAdmin;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  if ($[55] !== isAdmin) {
    t35 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setImportJobNotesOpen(true)}><Typography textAlign="center">Import Job Notes</Typography></MenuItem>;
    $[55] = isAdmin;
    $[56] = t35;
  } else {
    t35 = $[56];
  }
  let t36;
  if ($[57] !== isAdmin) {
    t36 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setImportChangeDateLogOpen(true)}><Typography textAlign="center">Import Job Change Date Log</Typography></MenuItem>;
    $[57] = isAdmin;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  let t37;
  if ($[59] !== doServerAction || $[60] !== isAdmin || $[61] !== pushToast) {
    t37 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => {
      doServerAction(_temp17, result_0 => {
        if (!result_0 || typeof result_0 !== "object" || !("data" in result_0)) {
          return;
        }
        const {
          setTrue,
          setFalse,
          total
        } = result_0.data;
        pushToast({
          message: `PO refresh complete — ${total} jobs checked, ${setTrue} set open, ${setFalse} set closed`,
          type: ToastType.success
        });
      });
    }}><Typography textAlign="center">Refresh Purchase Orders</Typography></MenuItem>;
    $[59] = doServerAction;
    $[60] = isAdmin;
    $[61] = pushToast;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  let t38;
  if ($[63] !== isAdmin) {
    t38 = isAdmin && <MenuItem sx={{
      display: "none "
    }} onClick={() => setAssignSalesforceIdOpen(true)}><Typography textAlign="center">Assign salesforceId from excel</Typography></MenuItem>;
    $[63] = isAdmin;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== isAdmin) {
    t39 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setFixUsersFromSharepointOpen(true)}><Typography textAlign="center">Fix users according to SharePoint</Typography></MenuItem>;
    $[65] = isAdmin;
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  let t40;
  if ($[67] !== isAdmin) {
    t40 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setMigrateSiteDataOpen(true)}><Typography textAlign="center">Migrate site data from excel</Typography></MenuItem>;
    $[67] = isAdmin;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] !== env || $[70] !== isAdmin) {
    t41 = isAdmin && <MenuItem sx={{
      display: env === "production" ? "none" : "block"
    }} onClick={() => setSendCustomerReportNightlyOpen(true)}><Typography textAlign="center">Send Customer Report Nightly (Test Run)</Typography></MenuItem>;
    $[69] = env;
    $[70] = isAdmin;
    $[71] = t41;
  } else {
    t41 = $[71];
  }
  let t42;
  if ($[72] !== isAdmin) {
    t42 = isAdmin && <MenuItem sx={{
      display: "none"
    }} onClick={() => setFixWorkstationsFromCsvOpen(true)}><Typography textAlign="center">Fix workstations from CSV</Typography></MenuItem>;
    $[72] = isAdmin;
    $[73] = t42;
  } else {
    t42 = $[73];
  }
  let t43;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      pb: 0
    };
    $[74] = t43;
  } else {
    t43 = $[74];
  }
  let t44;
  if ($[75] !== lastLoginAt) {
    t44 = lastLoginAt ? dateToStringUTC(lastLoginAt) : "";
    $[75] = lastLoginAt;
    $[76] = t44;
  } else {
    t44 = $[76];
  }
  let t45;
  if ($[77] !== t44) {
    t45 = <MenuItem disabled={true} sx={t43}><Typography fontSize={13}>Last Login: {t44}</Typography></MenuItem>;
    $[77] = t44;
    $[78] = t45;
  } else {
    t45 = $[78];
  }
  let t46;
  if ($[79] !== anchorElUser || $[80] !== t17 || $[81] !== t19 || $[82] !== t20 || $[83] !== t21 || $[84] !== t22 || $[85] !== t23 || $[86] !== t24 || $[87] !== t25 || $[88] !== t26 || $[89] !== t27 || $[90] !== t28 || $[91] !== t29 || $[92] !== t30 || $[93] !== t31 || $[94] !== t32 || $[95] !== t33 || $[96] !== t34 || $[97] !== t35 || $[98] !== t36 || $[99] !== t37 || $[100] !== t38 || $[101] !== t39 || $[102] !== t40 || $[103] !== t41 || $[104] !== t42 || $[105] !== t45) {
    t46 = <Menu sx={t14} id="menu-appbar" anchorEl={anchorElUser} anchorOrigin={t15} keepMounted={true} transformOrigin={t16} open={t17} onClose={handleCloseUserMenu}>{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}{t45}</Menu>;
    $[79] = anchorElUser;
    $[80] = t17;
    $[81] = t19;
    $[82] = t20;
    $[83] = t21;
    $[84] = t22;
    $[85] = t23;
    $[86] = t24;
    $[87] = t25;
    $[88] = t26;
    $[89] = t27;
    $[90] = t28;
    $[91] = t29;
    $[92] = t30;
    $[93] = t31;
    $[94] = t32;
    $[95] = t33;
    $[96] = t34;
    $[97] = t35;
    $[98] = t36;
    $[99] = t37;
    $[100] = t38;
    $[101] = t39;
    $[102] = t40;
    $[103] = t41;
    $[104] = t42;
    $[105] = t45;
    $[106] = t46;
  } else {
    t46 = $[106];
  }
  let t47;
  if ($[107] !== t13 || $[108] !== t46) {
    t47 = <Box sx={t8}>{t13}{t46}</Box>;
    $[107] = t13;
    $[108] = t46;
    $[109] = t47;
  } else {
    t47 = $[109];
  }
  let t48;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = () => setSyncOptOpen(false);
    $[110] = t48;
  } else {
    t48 = $[110];
  }
  let t49;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = {};
    $[111] = t49;
  } else {
    t49 = $[111];
  }
  let t50;
  if ($[112] !== pushToast) {
    t50 = <Button variant="contained" onClick={() => {
      startTransition(() => {
        syncEntitiesToOpt().then(() => {
          pushToast({
            message: "Entities synced to OPT",
            type: ToastType.success
          });
        }).catch(() => {
          pushToast({
            message: "Error syncing entities to OPT",
            type: ToastType.error
          });
        }).finally(() => {
          setSyncOptOpen(false);
        });
      });
    }}>Sync OPT</Button>;
    $[112] = pushToast;
    $[113] = t50;
  } else {
    t50 = $[113];
  }
  let t51;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <Typography sx={{
      mb: 1
    }}>Are you sure you want to sync all the entities (users, sites, materials, recipes, operations and workstations) to OPT?</Typography>;
    $[114] = t51;
  } else {
    t51 = $[114];
  }
  let t52;
  if ($[115] !== isSyncOptOpen || $[116] !== isSyncing || $[117] !== t50) {
    t52 = <Modal isOpen={isSyncOptOpen} onClose={t48} title="Sync Entities to OPT" disableClose={isSyncing} isLoading={false} ContentProps={t49} actions={t50}>{t51}</Modal>;
    $[115] = isSyncOptOpen;
    $[116] = isSyncing;
    $[117] = t50;
    $[118] = t52;
  } else {
    t52 = $[118];
  }
  let t53;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = () => setMigrationModalOpen(false);
    $[119] = t53;
  } else {
    t53 = $[119];
  }
  let t54;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = {};
    $[120] = t54;
  } else {
    t54 = $[120];
  }
  let t55;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      mb: 3
    };
    $[121] = t55;
  } else {
    t55 = $[121];
  }
  let t56;
  if ($[122] !== currentStep || $[123] !== migrationScripts.length) {
    t56 = currentStep <= migrationScripts.length && <Typography component="span" sx={{
      display: "block",
      mt: 1,
      fontWeight: "bold",
      color: "primary.main"
    }}>Current step: {currentStep}</Typography>;
    $[122] = currentStep;
    $[123] = migrationScripts.length;
    $[124] = t56;
  } else {
    t56 = $[124];
  }
  let t57;
  if ($[125] !== migrationScripts.length || $[126] !== t56) {
    t57 = <Typography sx={t55}>Run database migration scripts to set up the job system. Execute scripts in order from 1 to {migrationScripts.length}.{t56}</Typography>;
    $[125] = migrationScripts.length;
    $[126] = t56;
    $[127] = t57;
  } else {
    t57 = $[127];
  }
  let t58;
  if ($[128] !== currentStep || $[129] !== handleRunMigration || $[130] !== isLoading || $[131] !== migrationScripts) {
    let t59;
    if ($[133] !== currentStep || $[134] !== handleRunMigration || $[135] !== isLoading) {
      t59 = script_0 => {
        const isCurrentStep = script_0.number === currentStep;
        const isCompleted = script_0.status === "completed";
        const isRunning = script_0.status === "running";
        const isError = script_0.status === "error";
        const isDisabled = script_0.number !== currentStep || isLoading;
        const getStepColor = () => {
          if (isCompleted) {
            return "success.main";
          }
          if (isRunning) {
            return "warning.main";
          }
          if (isError) {
            return "error.main";
          }
          if (isCurrentStep) {
            return "primary.main";
          }
          return "grey.400";
        };
        const getStepIcon = () => {
          if (isCompleted) {
            return "\u2713";
          }
          if (isRunning) {
            return "\u27F3";
          }
          if (isError) {
            return "\u2717";
          }
          return script_0.number;
        };
        return <ListItem key={script_0.number} sx={{
          border: 1,
          borderColor: isCurrentStep ? "primary.main" : isCompleted ? "success.main" : isError ? "error.main" : "divider",
          borderRadius: 1,
          mb: 1,
          backgroundColor: isCompleted ? "success.light" : isError ? "error.light" : isCurrentStep ? "primary.light" : "background.paper",
          opacity: isDisabled && !isCurrentStep ? 0.6 : 1
        }}><Box sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: 2
          }}><Typography variant="h6" sx={{
              minWidth: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: getStepColor(),
              color: "white",
              borderRadius: "50%",
              fontWeight: "bold",
              animation: isRunning ? "spin 1s linear infinite" : "none",
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(0deg)"
                },
                "100%": {
                  transform: "rotate(360deg)"
                }
              }
            }}>{getStepIcon()}</Typography><ListItemText primary={script_0.name} secondary={<>{script_0.fileName}{isCompleted && <Typography component="span" sx={{
                color: "success.main",
                ml: 1
              }}>• Completed</Typography>}{isRunning && <Typography component="span" sx={{
                color: "warning.main",
                ml: 1
              }}>• Running...</Typography>}{isError && <Typography component="span" sx={{
                color: "error.main",
                ml: 1
              }}>• Error</Typography>}</>} sx={{
              flexGrow: 1
            }} /><Button disabled={isDisabled} variant={isCurrentStep ? "contained" : "outlined"} size="small" onClick={() => handleRunMigration(script_0.number, script_0.fileName)} sx={{
              minWidth: 80,
              ...(isCompleted && {
                backgroundColor: "success.main",
                "&:hover": {
                  backgroundColor: "success.dark"
                }
              }),
              ...(isError && {
                backgroundColor: "error.main",
                "&:hover": {
                  backgroundColor: "error.dark"
                }
              })
            }}>{isCompleted ? "Done" : isRunning ? "Running..." : isError ? "Retry" : "Run"}</Button></Box></ListItem>;
      };
      $[133] = currentStep;
      $[134] = handleRunMigration;
      $[135] = isLoading;
      $[136] = t59;
    } else {
      t59 = $[136];
    }
    t58 = migrationScripts.map(t59);
    $[128] = currentStep;
    $[129] = handleRunMigration;
    $[130] = isLoading;
    $[131] = migrationScripts;
    $[132] = t58;
  } else {
    t58 = $[132];
  }
  let t59;
  if ($[137] !== t58) {
    t59 = <List>{t58}</List>;
    $[137] = t58;
    $[138] = t59;
  } else {
    t59 = $[138];
  }
  let t60;
  if ($[139] !== isLoading || $[140] !== isMigrationModalOpen || $[141] !== t57 || $[142] !== t59) {
    t60 = <Modal isOpen={isMigrationModalOpen} onClose={t53} title="Job Database Migration" maxWidth="md" disableClose={isLoading} isLoading={false} actions={null} ContentProps={t54}>{t57}{t59}</Modal>;
    $[139] = isLoading;
    $[140] = isMigrationModalOpen;
    $[141] = t57;
    $[142] = t59;
    $[143] = t60;
  } else {
    t60 = $[143];
  }
  let t61;
  if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = () => {
      setDrawingMigrationOpen(false);
      setJobIds("");
      setDrawingMigrationRunning(false);
    };
    $[144] = t61;
  } else {
    t61 = $[144];
  }
  let t62;
  if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = {};
    $[145] = t62;
  } else {
    t62 = $[145];
  }
  let t63;
  if ($[146] !== isDrawingMigrationRunning || $[147] !== jobIds) {
    t63 = !jobIds.trim() || !/^\d+(?:\s*,\s*\d+)*$/.test(jobIds.trim()) || isDrawingMigrationRunning;
    $[146] = isDrawingMigrationRunning;
    $[147] = jobIds;
    $[148] = t63;
  } else {
    t63 = $[148];
  }
  let t64;
  if ($[149] !== doServerAction || $[150] !== jobIds || $[151] !== pushToast) {
    t64 = () => {
      setDrawingMigrationRunning(true);
      doServerAction(async () => migrateDrawings(jobIds), response_0 => {
        pushToast({
          message: `Successfully updated drawings for ${response_0} jobs`,
          type: ToastType.success
        });
        setDrawingMigrationOpen(false);
        setDrawingMigrationRunning(false);
        setJobIds("");
      });
    };
    $[149] = doServerAction;
    $[150] = jobIds;
    $[151] = pushToast;
    $[152] = t64;
  } else {
    t64 = $[152];
  }
  let t65;
  if ($[153] !== t63 || $[154] !== t64) {
    t65 = <Button variant="contained" disabled={t63} onClick={t64}>Update Drawings</Button>;
    $[153] = t63;
    $[154] = t64;
    $[155] = t65;
  } else {
    t65 = $[155];
  }
  let t66;
  if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <Typography sx={{
      mb: 3
    }}>Enter a comma-separated list of job IDs to update their drawing information.</Typography>;
    $[156] = t66;
  } else {
    t66 = $[156];
  }
  let t67;
  if ($[157] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = e => setJobIds(e.target.value);
    $[157] = t67;
  } else {
    t67 = $[157];
  }
  let t68;
  if ($[158] !== jobIds) {
    t68 = !!jobIds.trim() && !/^\d+(?:\s*,\s*\d+)*$/.test(jobIds.trim());
    $[158] = jobIds;
    $[159] = t68;
  } else {
    t68 = $[159];
  }
  const t69 = jobIds.trim() && !/^\d+(?:\s*,\s*\d+)*$/.test(jobIds.trim()) ? "Please enter valid comma-separated numbers" : "";
  let t70;
  if ($[160] !== isDrawingMigrationRunning || $[161] !== jobIds || $[162] !== t68 || $[163] !== t69) {
    t70 = <TextField label="Job IDs" fullWidth={true} value={jobIds} onChange={t67} placeholder="e.g., 1234, 5678, 91011" error={t68} helperText={t69} disabled={isDrawingMigrationRunning} />;
    $[160] = isDrawingMigrationRunning;
    $[161] = jobIds;
    $[162] = t68;
    $[163] = t69;
    $[164] = t70;
  } else {
    t70 = $[164];
  }
  let t71;
  if ($[165] !== isDrawingMigrationOpen || $[166] !== isDrawingMigrationRunning || $[167] !== t65 || $[168] !== t70) {
    t71 = <Modal isOpen={isDrawingMigrationOpen} onClose={t61} title="Update Job Drawings" maxWidth="sm" disableClose={isDrawingMigrationRunning} isLoading={false} ContentProps={t62} actions={t65}>{t66}{t70}</Modal>;
    $[165] = isDrawingMigrationOpen;
    $[166] = isDrawingMigrationRunning;
    $[167] = t65;
    $[168] = t70;
    $[169] = t71;
  } else {
    t71 = $[169];
  }
  const t72 = isSyncing || isDrawingMigrationRunning;
  const t73 = isSyncing ? "Syncing OPT..." : "Updating drawings...";
  let t74;
  if ($[170] !== t72 || $[171] !== t73) {
    t74 = <Backdrop isOpen={t72} text={t73} coverFullScreen={true} />;
    $[170] = t72;
    $[171] = t73;
    $[172] = t74;
  } else {
    t74 = $[172];
  }
  let t75;
  if ($[173] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = () => setImportJobNotesOpen(false);
    $[173] = t75;
  } else {
    t75 = $[173];
  }
  let t76;
  if ($[174] !== isImportJobNotesOpen) {
    t76 = <ImportJobNotesModal isOpen={isImportJobNotesOpen} onClose={t75} />;
    $[174] = isImportJobNotesOpen;
    $[175] = t76;
  } else {
    t76 = $[175];
  }
  let t77;
  if ($[176] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = () => setImportChangeDateLogOpen(false);
    $[176] = t77;
  } else {
    t77 = $[176];
  }
  let t78;
  if ($[177] !== isImportChangeDateLogOpen) {
    t78 = <ImportJobChangeDateLogModal isOpen={isImportChangeDateLogOpen} onClose={t77} />;
    $[177] = isImportChangeDateLogOpen;
    $[178] = t78;
  } else {
    t78 = $[178];
  }
  let t79;
  if ($[179] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = () => setAssignSalesforceIdOpen(false);
    $[179] = t79;
  } else {
    t79 = $[179];
  }
  let t80;
  if ($[180] !== isAssignSalesforceIdOpen) {
    t80 = <AssignSalesforceIdModal isOpen={isAssignSalesforceIdOpen} onClose={t79} />;
    $[180] = isAssignSalesforceIdOpen;
    $[181] = t80;
  } else {
    t80 = $[181];
  }
  let t81;
  if ($[182] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = () => setFixUsersFromSharepointOpen(false);
    $[182] = t81;
  } else {
    t81 = $[182];
  }
  let t82;
  if ($[183] !== isFixUsersFromSharepointOpen) {
    t82 = <FixUsersFromSharepointModal isOpen={isFixUsersFromSharepointOpen} onClose={t81} />;
    $[183] = isFixUsersFromSharepointOpen;
    $[184] = t82;
  } else {
    t82 = $[184];
  }
  let t83;
  if ($[185] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = () => setFixWorkstationsFromCsvOpen(false);
    $[185] = t83;
  } else {
    t83 = $[185];
  }
  let t84;
  if ($[186] !== isFixWorkstationsFromCsvOpen) {
    t84 = <FixWorkstationsFromCsvModal isOpen={isFixWorkstationsFromCsvOpen} onClose={t83} />;
    $[186] = isFixWorkstationsFromCsvOpen;
    $[187] = t84;
  } else {
    t84 = $[187];
  }
  let t85;
  if ($[188] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = () => setMigrateSiteDataOpen(false);
    $[188] = t85;
  } else {
    t85 = $[188];
  }
  let t86;
  if ($[189] !== isMigrateSiteDataOpen) {
    t86 = <MigrateSiteDataModal isOpen={isMigrateSiteDataOpen} onClose={t85} />;
    $[189] = isMigrateSiteDataOpen;
    $[190] = t86;
  } else {
    t86 = $[190];
  }
  let t87;
  if ($[191] === Symbol.for("react.memo_cache_sentinel")) {
    t87 = () => setSendCustomerReportNightlyOpen(false);
    $[191] = t87;
  } else {
    t87 = $[191];
  }
  let t88;
  if ($[192] !== isSendCustomerReportNightlyOpen) {
    t88 = <SendCustomerReportNightlyModal isOpen={isSendCustomerReportNightlyOpen} onClose={t87} />;
    $[192] = isSendCustomerReportNightlyOpen;
    $[193] = t88;
  } else {
    t88 = $[193];
  }
  let t89;
  if ($[194] !== t47 || $[195] !== t52 || $[196] !== t60 || $[197] !== t71 || $[198] !== t74 || $[199] !== t76 || $[200] !== t78 || $[201] !== t80 || $[202] !== t82 || $[203] !== t84 || $[204] !== t86 || $[205] !== t88) {
    t89 = <>{t47}{t52}{t60}{t71}{t74}{t76}{t78}{t80}{t82}{t84}{t86}{t88}</>;
    $[194] = t47;
    $[195] = t52;
    $[196] = t60;
    $[197] = t71;
    $[198] = t74;
    $[199] = t76;
    $[200] = t78;
    $[201] = t80;
    $[202] = t82;
    $[203] = t84;
    $[204] = t86;
    $[205] = t88;
    $[206] = t89;
  } else {
    t89 = $[206];
  }
  return t89;
};
function _temp(prev_0) {
  return prev_0 + 1;
}
function _temp2(t0) {
  const {
    palette,
    shadows
  } = t0;
  return {
    width: 40,
    height: 40,
    backgroundColor: palette.primary.main,
    boxShadow: shadows[1]
  };
}
function _temp3() {
  return signOut();
}
function _temp4() {
  return migrateSpJobFolder();
}
function _temp5() {
  return getSheetsDataExport();
}
function _temp6() {
  return migrateWorkflowStatus();
}
function _temp7() {
  return calculateStartByDate();
}
function _temp8() {
  return migrateJobFolderStructure();
}
function _temp9() {
  return assignFolderToOrphanJobs();
}
function _temp10() {
  return updateOperationsStatus();
}
function _temp11() {
  return migrateProjectInfo();
}
function _temp12() {
  return populateRouteOwner();
}
function _temp13() {
  return sendAllUsersUpdateToOpt();
}
function _temp14() {
  return sendOperationTypesToOpt();
}
function _temp15() {
  return sendAllWorkstationsToOpt();
}
function _temp16() {
  return sendAllWorkstationGroupsToOpt();
}
async function _temp17() {
  const result = await refreshPurchaseOrders();
  return {
    data: result
  };
}